/**
 * Error messages for Availability Scheduler APIs (internal only):
 * - Create / Update
 * - Show / Update / Delete / Candidate Slots / Remind Candidate
 */

const availabilityScheduler = {
  // Create / Update — internal API (404, 422, 400)
  err_ats_job_not_found: {
    message: 'Job not found. Select a different job.',
  },
  err_ats_application_not_found: {
    message: 'Candidate not found. Select a different candidate.',
  },
  err_sender_mailbox_not_connected: {
    message:
      "The selected sender's mailbox isn't connected. Choose a different sender.",
  },
  err_availability_link_required_in_email_body: {
    message: 'Add {{interview.availability_link}} to the email.',
  },
  err_invalid_ats_shared_email_id: {
    message:
      "This shared email isn't available for your account. Select a different shared email.",
  },

  // Show / Update / Delete / Candidate Slots / Remind Candidate
  err_ats_candidate_availability_not_found: {
    message: 'This candidate availability request no longer exists',
  },
};

export default availabilityScheduler;
